/** GxChain: a short vertical list of steps joined by a connector (what a decision set off, step by step). Each step has a small heading and free content. */
import type { ReactNode } from "react";
import "./chain.css";

export interface ChainStep { readonly id: string; readonly label: string; readonly children: ReactNode }

export function GxChain({ steps, testId }: { readonly steps: readonly ChainStep[]; readonly testId?: string }) {
  return (
    <ol className="gx-chain" data-testid={testId}>
      {steps.map((s) => (
        <li key={s.id} className="gx-chain-step" data-testid={testId === undefined ? undefined : `${testId}.${s.id}`}>
          <span className="gx-chain-dot" aria-hidden="true" />
          <div className="gx-chain-label gx-eyebrow">{s.label}</div>
          <div className="gx-chain-body">{s.children}</div>
        </li>
      ))}
    </ol>
  );
}
